import { render, staticRenderFns } from "./DetailAccount.vue?vue&type=template&id=2c8bd154&scoped=true&"
import script from "./DetailAccount.vue?vue&type=script&lang=js&"
export * from "./DetailAccount.vue?vue&type=script&lang=js&"
import style0 from "./DetailAccount.vue?vue&type=style&index=0&id=2c8bd154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8bd154",
  null
  
)

export default component.exports